import { useSyncExternalStore } from 'react';
import { alternarCorrida, assinarAtalhos, geracaoAtalhos, pressionada, rotuloTecla, teclaDe } from '../../input/atalhos';
import { t } from '../../i18n/idioma';

/** Fração de vigor que o galope gasta por passo (STAM_GALOPE do engine): abaixo disso não corre. */
const VIGOR_MIN = 0.06;

/**
 * Ícone sutil à esquerda do slot da arma: correndo (dourado), andando (cinza riscado) ou sem vigor (vermelho).
 * O clique faz o mesmo que o Shift. Protótipo: docs/prototipos/corrida-e-sem-arma-prototipo.html (B).
 */
export function IconeCorrida({ stam, stamMax }: { stam?: number; stamMax?: number }) {
  useSyncExternalStore(assinarAtalhos, geracaoAtalhos);
  const correndo = pressionada('galopar');
  const semVigor = correndo && stam != null && stamMax != null && stamMax > 0 && stam / stamMax < VIGOR_MIN;
  const estado = !correndo ? 'off' : semVigor ? 'sem' : 'on';
  const dica = t(`hud.corrida.${estado}`, { tecla: rotuloTecla(teclaDe('galopar')) });
  return (
    <button type="button" className={`bb-corrida bb-corrida--${estado}`} aria-pressed={correndo}
      aria-label={dica} title={dica} onClick={e => { alternarCorrida(); e.currentTarget.blur(); }}>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6 6l6 6-6 6" />
        <path d="M12 6l6 6-6 6" />
      </svg>
    </button>
  );
}
